import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, Container, Grid, Paper, Typography } from "@material-ui/core";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import EmailIcon from "@material-ui/icons/Email";
import LockIcon from "@material-ui/icons/Lock";
import PersonIcon from "@material-ui/icons/Person";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import PhoneIcon from "@material-ui/icons/Phone";
import SchoolIcon from "@material-ui/icons/School";
import authApi from "api/authApi";
import { useAppDispatch, useAppSelector } from "app/hooks";
import BACK_GROUND from "assets/img/bg_register1.jpg";
import InputField from "components/FormFields/InputField";
import { SelectField } from "components/FormFields/SelectFiled";
import { fetchDataOptions, selectListClass } from "features/Auth/options/optionsSlice";
import { UserRegister } from "models/auth";
import { ResponseStatus } from "models/common";
import { IClass } from "models/managerClass";
import moment from "moment";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import useStyles from "./style";

const schema = yup.object().shape({
  email: yup.string().email("* Vui lòng nhập đúng định dạng email"),
  staffId: yup.string().required("* Mã nhân viên bắt buộc nhập."),
  password: yup.string().required("* Mật khẩu bắt buộc nhập."),
  confirmPassword: yup
    .string()
    .required("* Xác nhận mật khẩu bắt buộc nhập.")
    .oneOf([yup.ref("password"), null], "* Mật khẩu xác nhận phải trùng khớp."),
  name: yup.string().required("* Họ và tên bắt buộc nhập."),
  classId: yup.string().required("* Lớp học bắt buộc chọn."),
});

export default function Register() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const listClass = useAppSelector(selectListClass);

  useEffect(() => {
    dispatch(fetchDataOptions());
  }, [dispatch]);

  const initialValues: UserRegister = {
    email: "",
    staffId: "",
    password: "",
    confirmPassword: "",
    name: "",
    areaId: "",
    phone: "",
    provinceId: "",
    dateOfJoining: "",
    workTypeId: "",
    position: "",
    farmId: "",
    departmentId: "",
    newProvinceId: "",
    classId: "",
  };

  const { control, handleSubmit } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(schema),
  });

  const handleSubmitForm = async (infoUser: UserRegister) => {
    try {
      const res: ResponseStatus = await authApi.register({
        ...infoUser,
        areaId: 3,
        departmentId: 2,
        newProvinceId: 45,
        position: "Nhân viên",
        dateOfJoining: moment(new Date()).format("YYYY-MM-DD"),
        classId: Number(infoUser.classId),
      });
      if (res.responseCode === "00") {
        toast.success(t("auth.registerSuccess") || "Đăng ký tài khoản thành công!");
        navigate("/login");
      } else if (res.responseCode === "02") {
        toast.error(t("auth.emalOrStaffIdExisted") || "Email hoặc Mã nhân viên đã tồn tại.");
      } else if (res.responseCode === "01") {
        toast.error(t("auth.missingField") || "Vui lòng nhập đầy đủ các thông tin bắt buộc.");
      } else {
        toast.error(res.responseDescription || "Đăng ký thất bại.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const classes = useStyles({ background: BACK_GROUND });

  return (
    <Box className={classes.background}>
      <Container className={classes.container}>
        {/* Header Banner */}
        <Box className={classes.headerBanner}>
          <Box className={classes.headerGlow} />
          <Box className={classes.headerBadge}>
            <PersonAddIcon style={{ fontSize: 16 }} />
            ĐĂNG KÝ HỌC VIÊN MỚI
          </Box>
          <Typography className={classes.headerTitle}>
            TẠO TÀI KHOẢN HỌC TẬP GPET EDU
          </Typography>
          <Typography className={classes.headerSubtitle}>
            Điền đầy đủ thông tin bên dưới để đăng ký tài khoản học viên chính thức trên hệ thống đào tạo GPET.
          </Typography>
        </Box>

        {/* Register Card Form */}
        <Paper className={classes.registerCard} elevation={0}>
          <Box className={classes.sectionHeader}>
            <PersonAddIcon style={{ fontSize: 24, color: "#4F46E5" }} />
            <Typography className={classes.sectionTitle}>
              THÔNG TIN ĐĂNG KÝ
            </Typography>
          </Box>

          <form onSubmit={handleSubmit(handleSubmitForm)} className={classes.formContainer}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Box className={classes.fieldGroup}>
                  <Typography className={classes.formLabel}>
                    <AssignmentIndIcon style={{ fontSize: 18, color: "#4F46E5" }} />
                    {t("auth.code") || "MÃ NHÂN VIÊN"} *
                  </Typography>
                  <InputField
                    name="staffId"
                    label={t("auth.code") || "Nhập mã nhân viên"}
                    control={control}
                    borderRadius="12px"
                    required
                    autocomplete
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box className={classes.fieldGroup}>
                  <Typography className={classes.formLabel}>
                    <EmailIcon style={{ fontSize: 18, color: "#4F46E5" }} />
                    {t("auth.email") || "EMAIL CÁ NHÂN"} *
                  </Typography>
                  <InputField
                    name="email"
                    label={t("auth.email") || "Nhập email cá nhân"}
                    control={control}
                    borderRadius="12px"
                    required
                    autocomplete
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box className={classes.fieldGroup}>
                  <Typography className={classes.formLabel}>
                    <LockIcon style={{ fontSize: 18, color: "#4F46E5" }} />
                    {t("auth.password") || "MẬT KHẨU"} *
                  </Typography>
                  <InputField
                    name="password"
                    label={t("auth.password") || "Nhập mật khẩu mới"}
                    control={control}
                    borderRadius="12px"
                    inputType="password"
                    required
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box className={classes.fieldGroup}>
                  <Typography className={classes.formLabel}>
                    <LockIcon style={{ fontSize: 18, color: "#4F46E5" }} />
                    {t("auth.confirm.password") || "XÁC NHẬN MẬT KHẨU"} *
                  </Typography>
                  <InputField
                    name="confirmPassword"
                    inputType="password"
                    label={t("auth.confirm.password") || "Nhập lại mật khẩu"}
                    control={control}
                    borderRadius="12px"
                    required
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box className={classes.fieldGroup}>
                  <Typography className={classes.formLabel}>
                    <PersonIcon style={{ fontSize: 18, color: "#4F46E5" }} />
                    {t("auth.fullName") || "HỌ VÀ TÊN"} *
                  </Typography>
                  <InputField
                    name="name"
                    label={t("auth.fullName") || "Nhập họ và tên đầy đủ"}
                    control={control}
                    borderRadius="12px"
                    required
                    autocomplete
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box className={classes.fieldGroup}>
                  <Typography className={classes.formLabel}>
                    <PhoneIcon style={{ fontSize: 18, color: "#4F46E5" }} />
                    {t("auth.phone") || "SỐ ĐIỆN THOẠI"}
                  </Typography>
                  <InputField
                    name="phone"
                    label={t("auth.phone") || "Nhập số điện thoại"}
                    control={control}
                    borderRadius="12px"
                    type="number"
                    autocomplete
                  />
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box className={classes.fieldGroup}>
                  <Typography className={classes.formLabel}>
                    <SchoolIcon style={{ fontSize: 18, color: "#4F46E5" }} />
                    {t("auth.class") || "LỚP ĐÀO TẠO"} *
                  </Typography>
                  <SelectField
                    name="classId"
                    label={t("auth.class") || "Chọn lớp đào tạo"}
                    options={listClass.map((item: IClass) => ({
                      id: item.id,
                      name: item.name,
                    }))}
                    control={control}
                    borderRadius="12px"
                    required
                  />
                </Box>
              </Grid>
            </Grid>

            <Box textAlign="center" mt={3}>
              <Button
                type="submit"
                variant="contained"
                startIcon={<PersonAddIcon />}
                className={classes.btnSubmit}
              >
                {t("auth.register") || "HOÀN TẤT ĐĂNG KÝ"}
              </Button>
            </Box>

            <Typography className={classes.loginPrompt}>
              {t("auth.haveAccount") || "Đã có tài khoản học viên?"}
              <span onClick={() => navigate("/login")}>
                {t("auth.login") || "Đăng nhập ngay"}
              </span>
            </Typography>
          </form>
        </Paper>
      </Container>
    </Box>
  );
}
